import { garageDoorStepsMap } from '@icc/garage-door/configurator';
import { pleatedBlindStepsMap } from '@icc/pleated-blind/configurator';
import { StepComponentType } from '@icc/configurator/shared';
import { windowStepsMap, doorStepsMap } from '@icc/window-door/configurator';
import { shutterStepsMap } from '@icc/shutter/configurator';
import { mosquitoScreenStepsMap } from '@icc/mosquito-screen/configurator';
import { accessoryStepsMap } from '@icc/window-door/configurator';
import { awningStepsMap } from '@icc/awning/configurator';
import { coupledWindowStepsMap } from '@icc/coupled-window/configurator';

export const stepsMap: {
    [configurator: string]: {
        [stepId: string]: StepComponentType;
    };
} = {
    window: windowStepsMap,
    hs: windowStepsMap,
    folding_door: windowStepsMap,
    sliding_door: windowStepsMap,
    door: doorStepsMap,
    garage_door: garageDoorStepsMap,
    roller_shutter: shutterStepsMap,
    external_blind: shutterStepsMap,
    mosquito: mosquitoScreenStepsMap,
    complementary_goods: accessoryStepsMap,
    awning: awningStepsMap,
    pleated_blind: pleatedBlindStepsMap,
    coupled_window: coupledWindowStepsMap
};
